export default "__VITE_ASSET__BR6ytydH__"